import type { GroupingItem } from '@vedalib/editor/lib/elements'
import { FileUsageSource } from '@vedalib/editor/lib/files'
import { generateId } from '@vedalib/editor/lib/utils/id'
import React, { useCallback } from 'react'

import type { IRenderButtonAddItem } from 'components/uiKit/ArrayControl/types'
import Button from 'components/uiKit/Button'
import { KitSize } from 'components/uiKit/KitTypes'
import { t } from 'services/Translation'

const GroupingFormValueAddAnswer: React.FC<IRenderButtonAddItem<GroupingItem>> = ({
  name,
  max,
  array,
  onChange,
}) => {
  const handleAdd = useCallback(() => {
    const item: GroupingItem = {
      value: generateId(),
      label: `${t('elements.grouping.form.answer')} #${array.length + 1}`,
      image: { source: FileUsageSource.file, id: '', accessibility: '' },
      overlay: null,
    }
    onChange?.([...array, item], { command: 'add', item })
  }, [onChange, array])

  return (
    <Button
      disabled={Boolean(max && array.length >= max)}
      name={`${name}.addItem`}
      onClick={handleAdd}
      size={KitSize.L}
      styleType='secondary'
      fluid
    >
      {t('uiKit.button.add')}
    </Button>
  )
}

export default React.memo(GroupingFormValueAddAnswer) as typeof GroupingFormValueAddAnswer
